import React from 'react'

const GetHelpIcon = ({ className = '' }) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_174:1936)">
        <path
          d="M14 1.5C14.2652 1.5 14.5196 1.60536 14.7071 1.79289C14.8946 1.98043 15 2.23478 15 2.5V14.5C15 14.7652 14.8946 15.0196 14.7071 15.2071C14.5196 15.3946 14.2652 15.5 14 15.5H2C1.73478 15.5 1.48043 15.3946 1.29289 15.2071C1.10536 15.0196 1 14.7652 1 14.5V2.5C1 2.23478 1.10536 1.98043 1.29289 1.79289C1.48043 1.60536 1.73478 1.5 2 1.5H14ZM2 0.5C1.46957 0.5 0.960859 0.710714 0.585786 1.08579C0.210714 1.46086 0 1.96957 0 2.5L0 14.5C0 15.0304 0.210714 15.5391 0.585786 15.9142C0.960859 16.2893 1.46957 16.5 2 16.5H14C14.5304 16.5 15.0391 16.2893 15.4142 15.9142C15.7893 15.5391 16 15.0304 16 14.5V2.5C16 1.96957 15.7893 1.46086 15.4142 1.08579C15.0391 0.710714 14.5304 0.5 14 0.5H2Z"
          fill="white"
          fillOpacity="0.5"
        />
        <path
          d="M5.2551 6.286C5.25373 6.31829 5.25898 6.35053 5.27053 6.38072C5.28208 6.41091 5.29968 6.43841 5.32225 6.46155C5.34482 6.48468 5.37189 6.50296 5.40179 6.51524C5.43168 6.52753 5.46378 6.53357 5.4961 6.533H6.3211C6.4591 6.533 6.5691 6.42 6.5871 6.283C6.6771 5.627 7.1271 5.149 7.9291 5.149C8.6151 5.149 9.2431 5.492 9.2431 6.317C9.2431 6.952 8.8691 7.244 8.2781 7.688C7.6051 8.177 7.0721 8.748 7.1101 9.675L7.1131 9.892C7.11415 9.95761 7.14095 10.0202 7.18772 10.0662C7.23449 10.1122 7.29748 10.138 7.3631 10.138H8.1741C8.2404 10.138 8.30399 10.1117 8.35087 10.0648C8.39776 10.0179 8.4241 9.9543 8.4241 9.888V9.783C8.4241 9.065 8.6971 8.856 9.4341 8.297C10.0431 7.834 10.6781 7.32 10.6781 6.241C10.6781 4.73 9.4021 4 8.0051 4C6.7381 4 5.3501 4.59 5.2551 6.286ZM6.8121 12.049C6.8121 12.582 7.2371 12.976 7.8221 12.976C8.4311 12.976 8.8501 12.582 8.8501 12.049C8.8501 11.497 8.4301 11.109 7.8211 11.109C7.2371 11.109 6.8121 11.497 6.8121 12.049Z"
          fill="white"
          fillOpacity="0.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_174:1936">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default GetHelpIcon
